import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef, OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';
import {VanBanDenChoGiaoXLComponent} from './chogiaoxuly/chogiaoxuly.component';
import {VanBanDenDaVaoSoComponent} from './davaoso/davaoso.component';
import {VanBanDenChuaXuLyComponent} from './vanbanchuaxuly/vanbanchuaxuly.component';
import {VanBanDenDangXuLyComponent} from './vanbandangxuly/vanbandangxuly.component';
import {VanBanDenHoanThanhComponent} from './vanbanhoanthanh/vanbanhoanthanh.component';
import {VanBanDenTongHopComponent} from './tonghop/tonghop.component';
import {SoanVanBanDenComponent} from './soanvanban/create.component';
import {GiaoViecNhanhComponent} from './giaoviecnhanh/giaoviecnhanh.component';
import {TatCaVanBanDenComponent} from './vanban/vanban.component';
import {PhoCapVanBanDenComponent} from './quanlyphocap/phocap.component';
import {VanBanDenService} from '../../../service/vanbanden/service-vanbanden';
import {CommandUtil} from '../../../global/commandutil';
import {environment} from '../../../../environments/environment';
import {Sessioncommand} from '../../../global/sessioncommand';
import {SVTVanBanDenComponent} from './quanlyso/quanlyso.component';
import {ActivatedRoute} from '@angular/router';
import {NavItemService} from '../../../service/staff/service-navitem';
import {TongHopYKienVanBanDenComponent} from './xuly/tonghop.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {InSoCongVanDenComponent} from './insocv/insocv.component';
import {DSButPheVanBanDenComponent} from './butphe/danhsach.component';
import {GroupStaffsService} from '../../../service/staff/service-groupstaffs';
@Component({
  templateUrl: './vanbanden.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VanBanDenComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public showRef: ComponentRef<Object>;
  public language = language;
  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number = 0;
  public totalPhoCap: number = 0;
  public totalChuaPhoCap: number = 0;
  public totalChoGiaoXuLy: number = 0;
  public totalDaVaoSo: number = 0;

  public viewTotalInternal;
  public  permissonQLSVBD: boolean = false;
  public  permissonGXLVBD: boolean = false;
  public  permissionXLVBD: boolean = false;
  public  permissionGVNhanh: boolean = false;
  public  permissionXemSVBD: boolean = false;
  public  permissionButPheVB: boolean = false;
  public  colMain: string = 'col-md-9';
  public  titleCard: string = language.vanbanden;
  public apQuyTrinh: boolean = environment.apButPheVanBanDen;
  public status: number[] = [
    environment.chogiaoxuly
  ];
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiGiaoXuLy: number = Sessioncommand.staffId;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;

  constructor(public componentFactoryResolver: ComponentFactoryResolver,
              public vanBanDenService: VanBanDenService,
              public route: ActivatedRoute,
              public navItemService: NavItemService,
              public bsModalService: BsModalService,
              public groupStaffsService: GroupStaffsService
            ) {
  }


  public showComponent(component)
  {
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const comRef= viewRef.createComponent(factory);
    this.showRef= comRef;
  }
  public loadTotal()
  {
    this.nguoiGiaoXuLy = this.permissonGXLVBD === true? -1: this.nguoiGiaoXuLy;
    this.vanBanDenService.getCountByKeyword('', -1,-1, this.status.join(), CommandUtil.defaultValue, this.nguoiGiaoXuLy, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);
    this.vanBanDenService.getCountByKeyword('', -1,-1,'-1', CommandUtil.defaultValue, -1, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalDaVaoSo = recordCount);
    this.vanBanDenService.getCountByXLKeyword('',-1, -1, environment.chuaxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1,'','').subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1,environment.dangxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1, '','').subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1, environment.hoanthanh.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1, '','').subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.vanBanDenService.getCountByKeyword('', -1,-1,'-1' , CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword('', -1,-1,'-1', CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    Sessioncommand.vanBanDenStatus = 1;
  }
  ngAfterViewInit() {
    this.route.queryParams.
    subscribe(params => {
        if (params.ty == null)
          this.showTongHop();
        else {
                if(params.ty == 'cgxl')
                  this.showChoGXL();
                if(params.ty == 'dvso')
                  this.showDaVaoSo();
                if(params.ty == 'cxl')
                  this.showChuaXuLy();
                if(params.ty == 'dxl')
                  this.showDangXuLy();
                if(params.ty == 'ht')
                  this.showHoanThanh();
                if(params.ty == 'pc')
                  this.showQuanLyPhoCap();
            }
      });
    this.loadTotal();
   this.viewTotalInternal= setInterval(() => {
      if (Sessioncommand.vanBanDenStatus === 0 )
        this.loadTotal();
    }, 2000);
  }
  ngOnInit(): void {
    Sessioncommand.sideBarActive = true;
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0030', true).subscribe(
      x => {
          this.permissonQLSVBD = x >0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {
        this.permissonGXLVBD = x >0? true: false;
        this.nguoiGiaoXuLy = this.permissonGXLVBD === true? -1: this.nguoiGiaoXuLy;
        this.vanBanDenService.getCountByKeyword('',  -1,-1,this.status.join(), CommandUtil.defaultValue, this.nguoiGiaoXuLy, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);
      }
    );

    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0031', true).subscribe(
      x => {
        this.permissionXLVBD = x >0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0048', true).subscribe(
      x => {
        this.permissionGVNhanh = x >0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0027', true).subscribe(
      x => {
        this.permissionXemSVBD = x >0? true: false;
      }
    );
    if(this.apQuyTrinh=== true) {
      this.groupStaffsService.checkLanhDao(Sessioncommand.staffId).subscribe(x => {
        this.permissionButPheVB = x > 0 ? true : false;
      });
    }
  }
  public inSoCongVan() {
    const modalEdit = this.bsModalService.show(InSoCongVanDenComponent);
    (<InSoCongVanDenComponent>modalEdit.content).edit(
    );
    (<InSoCongVanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  ngOnDestroy() {
    if ( this.viewTotalInternal) {
      clearInterval(this.viewTotalInternal);
    }
  }
  public showTongHop() {
    this.titleCard = language.tonghop;
   this.showComponent(VanBanDenTongHopComponent);

  }
  public showQuanLySo()
  {
    this.colMain = 'col-md-12';
    this.titleCard = language.quanlyso;
    this.showComponent(SVTVanBanDenComponent);
  }
  public showVaoSoVBDen() {
    this.titleCard = language.vaosovanbanden;
    this.showComponent(SoanVanBanDenComponent);
  }
  public changeColMain()
  {
    if(this.colMain === 'col-md-9')
        this.colMain= 'col-md-12';
    else
      this.colMain= 'col-md-9';
  }
  public showTatCa() {
    this.colMain = 'col-md-12';
    this.titleCard = language.tatcavanbanden;
    this.showComponent(TatCaVanBanDenComponent);
  }
  public showQuanLyPhoCap() {
    this.colMain = 'col-md-12';
    this.titleCard = language.quanlyphocap;
    this.showComponent(PhoCapVanBanDenComponent);
  }
  public showGiaoViecNhanh() {
    this.colMain = 'col-md-12';
    this.titleCard = language.giaoviecnhanh;
    this.showComponent(GiaoViecNhanhComponent);
  }
  public showChoGXL() {
    this.colMain = 'col-md-12';
    this.titleCard= language.vanbandenchogiaoxuly;
    this.showComponent(VanBanDenChoGiaoXLComponent);
  }
  public showDaVaoSo() {
    this.colMain = 'col-md-12';
    this.titleCard= language.vanbandendavaoso;
    this.showComponent(VanBanDenDaVaoSoComponent);
  }
  public showChuaXuLy() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbanden_chuaxuly;
    this.showComponent(VanBanDenChuaXuLyComponent);
  }
  public showDangXuLy() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbanden_dangxuly;
    this.showComponent(VanBanDenDangXuLyComponent);
  }
  public showButPheVanBan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbanden_butphe;
    this.showComponent(DSButPheVanBanDenComponent);
  }
  public showHoanThanh() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbanden_hoanthanh;
    this.showComponent(VanBanDenHoanThanhComponent);

  }

}

